

















import Vue from "vue"
export default Vue.extend({

  props:{
    pagename: String
  },

  data: () => ({
    obscrumbs: {
      "home":[
        {
          text: 'Home',
          iscurrent: true,
          href: '/',
        },
        {
          text: 'Login',
          iscurrent: false,
          href: '/login',
        },        
      ],
      "login":[
        {
          text: 'Home',
          iscurrent: false,
          href: '/',
        },
        {
          text: 'Login',
          iscurrent: true,
          href: '/login',
        },
      ],
      "iprequest":[
        {
          text: 'Home',
          iscurrent: false,
          href: '/',
        },
        {
          text: 'Ip Requests',
          iscurrent: true,
          href: '/ip-request',
        },
        {
          text: 'IP Blacklist',
          iscurrent: false,
          href: '/ip-blacklist',
        },        
      ],  
      "ipblacklist":[
        {
          text: 'Home',
          iscurrent: false,
          href: '/',
        },
        {
          text: 'Ip Requests',
          iscurrent: false,
          href: '/ip-request',
        },        
        {
          text: 'IP Blacklist',
          iscurrent: true,
          href: '/ip-blacklist',
        },
      ]  
    }
  }),
  
  computed:{
    get_scrumbs(){
      const pagename = this.pagename
      if(this.obscrumbs[pagename] == undefined)
        return []
      return this.obscrumbs[pagename]
    }
  },

  methods:{
    refresh(){
      //this.$forceUpdate();
      //this.$router.push({ name: pathname})
      //alert("refresh")
      //this.$router.go(0)
      //location.reload()
      (this as any).$router.go((this as any).$router.currentRoute)
    },
  }

})
